import InputTextField from "@/components/InputTextField/InputTextField";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  disabled: boolean;
};

const ContactPerson = ({ disabled }: Props) => {
  const { activeAsset, updateMetadata, isMetadataUpdating } =
    useMetadataFields();
  const isUpdating = isMetadataUpdating(activeAsset.id!, "owner");
  return (
    <InputTextField
      id="owner"
      labelText="Owner/ Contact person"
      toolTipText="Person or team to reach out concerning the asset(s)"
      initialValue={activeAsset.owner || ""}
      onBlur={(value: string) =>
        updateMetadata({
          owner: value,
        })
      }
      disabled={disabled || isUpdating}
    />
  );
};

export default ContactPerson;
